import { createWebHistory, createRouter } from "vue-router";
import VideoMessage from "../components/VideoMessage.vue";

const routes = [
  {
    path: "/",
    name: "VideoMessage",
    component: VideoMessage,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;